// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Typography,
//   IconButton,
//   CircularProgress,
//   Divider,
// } from '@mui/material';

// import {
//   EditOutlined,
//   LocationOn,
//   VisibilityOutlined,
//   MouseOutlined,
//   PhoneOutlined,
//   HomeOutlined,
//   KeyboardArrowDownOutlined,
//   BarChartOutlined,
//   ChevronRight,
//   CalendarTodayOutlined,
// } from '@mui/icons-material';

// import buildingImage from './../../../../Images/house.jpeg';
// import CustomSearchBar from './../../Lease Module/CustomSearch';
// import BottomNavbar from './../../Post Module/FormsBottomNavbar';
// import { BASE_URL } from './../../../Api/ApiUrls';


// // ---------------------------------------------------------------------
// // API URL
// // ---------------------------------------------------------------------
// const AD_PROPERTIES_URL =
//   'https://landnest.net:81/ad-properties/combined/';


// const NewLaunchingProfile = () => {

//   const [properties, setProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchQuery, setSearchQuery] = useState('');


//   // ---------------------------------------------------------------------
//   // Helpers
//   // ---------------------------------------------------------------------

//   const toAbsoluteUrl = (url) => {
//     if (!url) return null;

//     if (url.startsWith('http')) {
//       return url;
//     }

//     if (url.startsWith('/')) {
//       return `${BASE_URL}${url}`;
//     }

//     return `${BASE_URL}/${url}`;
//   };


//   const formatPrice = (price) => {

//     const value = Number(price) || 0;

//     if (!value) {
//       return 'Price on request';
//     }

//     if (value >= 10000000) {
//       return `₹${(value / 10000000).toFixed(2)}Cr`;
//     }

//     if (value >= 100000) {
//       return `₹${(value / 100000).toFixed(2)}L`;
//     }

//     return `₹${value.toLocaleString('en-IN')}`;
//   };


//   const formatDate = (dateStr) => {

//     if (!dateStr) {
//       return null;
//     }

//     const d = new Date(dateStr);

//     if (Number.isNaN(d.getTime())) {
//       return null;
//     }

//     return d.toLocaleDateString('en-IN', {
//       month: 'short',
//       year: 'numeric',
//     });
//   };


//   // ---------------------------------------------------------------------
//   // Data Fetching
//   // ---------------------------------------------------------------------

//   const fetchData = async () => {

//     try {

//       setLoading(true);

//       const response = await fetch(AD_PROPERTIES_URL);

//       const json = await response.json();

//       if (!response.ok || !json.success) {
//         throw new Error(
//           json?.message || 'Failed to fetch ad properties'
//         );
//       }


//       const rawList = json.data || [];


//       const parsed = rawList
//         .slice()
//         .sort(
//           (a, b) =>
//             new Date(b.created_at) -
//             new Date(a.created_at)
//         )
//         .map((item) => {

//           // -------------------------------------------------------------
//           // Images
//           // -------------------------------------------------------------

//           const heroImages = (item.hero_images || [])
//             .slice()
//             .sort(
//               (a, b) =>
//                 (a.order || 0) -
//                 (b.order || 0)
//             )
//             .map((img) =>
//               toAbsoluteUrl(img.image)
//             )
//             .filter(Boolean);


//           let images =
//             heroImages.length > 0
//               ? heroImages
//               : [buildingImage, buildingImage];


//           if (images.length === 1) {
//             images = [
//               images[0],
//               images[0],
//             ];
//           }


//           // -------------------------------------------------------------
//           // Configurations
//           // -------------------------------------------------------------

//           const configs =
//             item.configurations || [];


//           const bhkList = [
//             ...new Set(
//               configs
//                 .map((c) => c.bhk_type)
//                 .filter(Boolean)
//             ),
//           ];


//           const bhk =
//             bhkList.length
//               ? bhkList.join(', ')
//               : item.property_type || '—';


//           // -------------------------------------------------------------
//           // Price Range
//           // -------------------------------------------------------------

//           const configPrices = configs
//             .map((c) => Number(c.price))
//             .filter(
//               (p) =>
//                 !Number.isNaN(p) &&
//                 p > 0
//             );


//           let formattedPrice =
//             'Price on request';


//           if (configPrices.length) {

//             const min =
//               Math.min(...configPrices);

//             const max =
//               Math.max(...configPrices);


//             formattedPrice =
//               min === max
//                 ? formatPrice(min)
//                 : `${formatPrice(min)} - ${formatPrice(max)}`;

//           } else if (item.price) {

//             formattedPrice =
//               formatPrice(item.price);

//           }


//           // -------------------------------------------------------------
//           // Area
//           // -------------------------------------------------------------

//           const areas = configs
//             .map(
//               (c) =>
//                 c.built_up_area ||
//                 c.super_built_up_area ||
//                 c.carpet_area
//             )
//             .filter(
//               (a) =>
//                 a != null &&
//                 a > 0
//             );


//           const area =
//             areas.length > 0
//               ? `${Math.min(...areas)} - ${Math.max(
//                   ...areas
//                 )} sq.ft`
//               : item.site_area
//               ? `${item.site_area} ${
//                   item.units || 'sq.ft'
//                 }`
//               : '—';


//           // -------------------------------------------------------------
//           // Price Per Sqft
//           // -------------------------------------------------------------

//           let pricePerSqft = null;


//           if (
//             configPrices.length &&
//             areas.length
//           ) {

//             const avgPrice =
//               configPrices.reduce(
//                 (sum, price) =>
//                   sum + price,
//                 0
//               ) /
//               configPrices.length;


//             const avgArea =
//               areas.reduce(
//                 (sum, area) =>
//                   sum + area,
//                 0
//               ) /
//               areas.length;


//             if (avgArea > 0) {

//               pricePerSqft =
//                 Math.round(
//                   avgPrice /
//                     avgArea
//                 );

//             }
//           }


//           // -------------------------------------------------------------
//           // Possession
//           // -------------------------------------------------------------

//           const possession =
//             formatDate(
//               item.possession_date
//             ) || '—';


//           // -------------------------------------------------------------
//           // Location
//           // -------------------------------------------------------------

//           const location =
//             item.location ||
//             [
//               item.address,
//               item.city,
//             ]
//               .filter(Boolean)
//               .join(', ') ||
//             'Location not specified';


//           // -------------------------------------------------------------
//           // PERFORMANCE DATA
//           // -------------------------------------------------------------
//           // These values are coming directly from API
//           // -------------------------------------------------------------

//           const performance = {

//             totalViews:
//               Number(
//                 item.total_views
//               ) || 0,

//             totalClicks:
//               Number(
//                 item.total_clicks
//               ) || 0,

//             callClicks:
//               Number(
//                 item.call_clicks
//               ) || 0,

//             requestClicks:
//               Number(
//                 item.request_clicks
//               ) || 0,
//           };


//           // -------------------------------------------------------------
//           // Return Property
//           // -------------------------------------------------------------

//           return {

//             id: item.property_id,

//             title:
//               item.property_name ||
//               'Untitled Property',

//             category:
//               item.category_name ||
//               'Property',

//             location,

//             formattedPrice,

//             pricePerSqft:
//               pricePerSqft
//                 ? `₹${pricePerSqft.toLocaleString(
//                     'en-IN'
//                   )}/sq.ft`
//                 : null,

//             area,

//             bhk,

//             possession,

//             images,

//             // Dynamic performance data
//             performance,

//             propertyData: item,
//           };
//         });


//       setProperties(parsed);

//     } catch (error) {

//       console.error(
//         'Error fetching ad properties:',
//         error
//       );

//       setProperties([]);

//     } finally {

//       setLoading(false);

//     }
//   };


//   // ---------------------------------------------------------------------
//   // Initial API Call
//   // ---------------------------------------------------------------------

//   useEffect(() => {
//     fetchData();
//   }, []);


//   // ---------------------------------------------------------------------
//   // Filter Properties
//   // ---------------------------------------------------------------------

//   const filteredProperties =
//     properties.filter((property) => {

//       const search =
//         searchQuery.toLowerCase();

//       return (
//         property.title
//           .toLowerCase()
//           .includes(search) ||

//         property.location
//           .toLowerCase()
//           .includes(search) ||

//         property.category
//           .toLowerCase()
//           .includes(search)
//       );
//     });


//   // ---------------------------------------------------------------------
//   // Loading
//   // ---------------------------------------------------------------------

//   if (loading) {

//     return (
//       <Box
//         sx={{
//           backgroundColor: '#F8F9FA',
//           minHeight: '100vh',
//           display: 'flex',
//           flexDirection: 'column',
//           justifyContent: 'center',
//           alignItems: 'center',
//           gap: 3,
//         }}
//       >

//         <CircularProgress
//           size={40}
//           sx={{
//             color: '#4CAF50',
//           }}
//         />

//         <Typography
//           variant="h7"
//           sx={{
//             color: '#000000',
//             fontWeight: 600,
//           }}
//         >
//           Loading New Launching Profiles...
//         </Typography>

//       </Box>
//     );
//   }


//   // ---------------------------------------------------------------------
//   // Main UI
//   // ---------------------------------------------------------------------

//   return (

//     <Box
//       sx={{
//         backgroundColor: '#F8F9FA',
//         minHeight: '100vh',
//         pb: 10,
//       }}
//     >

//       {/* ================================================================
//           STICKY SEARCH BAR
//       ================================================================= */}

//       <Box
//         sx={{
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           right: 0,
//           zIndex: 1200,
//           px: 1,
//           py: 1,
//           backgroundColor: '#F8F9FA',
//         }}
//       >

//         <CustomSearchBar
//           value={searchQuery}
//           onChange={(e) =>
//             setSearchQuery(
//               e.target.value
//             )
//           }
//         />

//       </Box>


//       {/* ================================================================
//           CONTENT WRAPPER
//       ================================================================= */}

//       <Box
//         sx={{
//           pt: {
//             xs: '90px',
//             sm: '100px',
//           },
//         }}
//       >

//         {/* ==============================================================
//             PAGE HEADER
//         =============================================================== */}

//         <Box
//           sx={{
//             backgroundColor: '#fff',
//             px: 1,
//             py: 1,
//             borderBottom:
//               '1px solid #EAEAEA',
//             mb: 1,
//           }}
//         >

//           <Typography
//             variant="h6"
//             sx={{
//               fontWeight: 600,
//               color: '#000000',
//               fontSize: '1.1rem',
//             }}
//           >
//             New Launching Profile
//           </Typography>

//         </Box>


//         {/* ==============================================================
//             NO DATA
//         =============================================================== */}

//         {filteredProperties.length === 0 && (

//           <Box
//             sx={{
//               p: 3,
//               textAlign: 'center',
//             }}
//           >

//             <Typography
//               variant="body2"
//               color="text.secondary"
//             >
//               No new launching properties
//               found matching your search.
//             </Typography>

//           </Box>

//         )}


//         {/* ==============================================================
//             PROPERTY LIST
//         =============================================================== */}

//         {filteredProperties.map(
//           (property) => {

//             // ----------------------------------------------------------
//             // Dynamic Performance Metrics
//             // ----------------------------------------------------------

//             const performanceMetrics = [

//               {
//                 label: 'Total Views',
//                 subLabel: '(Impressions)',

//                 value:
//                   property.performance.totalViews.toLocaleString(
//                     'en-IN'
//                   ),

//                 icon: (
//                   <VisibilityOutlined
//                     sx={{
//                       fontSize: 15,
//                     }}
//                   />
//                 ),

//                 iconColor:
//                   '#4A90E2',

//                 bgColor:
//                   '#EAF4FF',
//               },


//               {
//                 label: 'Total Clicks',

//                 value:
//                   property.performance.totalClicks.toLocaleString(
//                     'en-IN'
//                   ),

//                 icon: (
//                   <MouseOutlined
//                     sx={{
//                       fontSize: 15,
//                     }}
//                   />
//                 ),

//                 iconColor:
//                   '#4A90E2',

//                 bgColor:
//                   '#EAF4FF',
//               },


//               {
//                 label: 'Call Clicks',

//                 value:
//                   property.performance.callClicks.toLocaleString(
//                     'en-IN'
//                   ),

//                 icon: (
//                   <PhoneOutlined
//                     sx={{
//                       fontSize: 15,
//                     }}
//                   />
//                 ),

//                 iconColor:
//                   '#4CAF50',

//                 bgColor:
//                   '#E8F5E9',
//               },


//               {
//                 label:
//                   'Request Property Clicks',

//                 value:
//                   property.performance.requestClicks.toLocaleString(
//                     'en-IN'
//                   ),

//                 icon: (
//                   <HomeOutlined
//                     sx={{
//                       fontSize: 15,
//                     }}
//                   />
//                 ),

//                 iconColor:
//                   '#4A90E2',

//                 bgColor:
//                   '#EAF4FF',
//               },

//             ];


//             return (

//               <Box
//                 key={property.id}
//                 sx={{
//                   p: 1,
//                 }}
//               >

//                 {/* ====================================================
//                     MAIN PROPERTY CARD
//                 ===================================================== */}

//                 <Box
//                   sx={{
//                     backgroundColor:
//                       '#fff',

//                     borderRadius: 3,

//                     overflow: 'hidden',

//                     boxShadow:
//                       '0 2px 10px rgba(0,0,0,0.05)',

//                     mb: 3,
//                   }}
//                 >

//                   {/* ==================================================
//                       IMAGES
//                   =================================================== */}

//                   <Box
//                     sx={{
//                       display: 'flex',
//                       gap: 1,
//                       p: 1.5,
//                       height: 240,
//                     }}
//                   >

//                     {/* Main Image */}

//                     <Box
//                       sx={{
//                         flex: 2.5,
//                         position:
//                           'relative',
//                         borderRadius: 2,
//                         overflow:
//                           'hidden',
//                       }}
//                     >

//                       <img
//                         src={
//                           property
//                             .images[0]
//                         }
//                         alt={
//                           property.title
//                         }
//                         style={{
//                           width: '100%',
//                           height: '100%',
//                           objectFit:
//                             'cover',
//                         }}
//                         onError={(e) => {
//                           e.currentTarget.src =
//                             buildingImage;
//                         }}
//                       />

//                     </Box>


//                     {/* Second Image */}

//                     <Box
//                       sx={{
//                         flex: 1,
//                         display: 'flex',
//                         flexDirection:
//                           'column',
//                         gap: 1,
//                       }}
//                     >

//                       <Box
//                         sx={{
//                           flex: 1,
//                           position:
//                             'relative',
//                           borderRadius: 2,
//                           overflow:
//                             'hidden',
//                         }}
//                       >

//                         <img
//                           src={
//                             property
//                               .images[1]
//                           }
//                           alt={
//                             property.title
//                           }
//                           style={{
//                             width:
//                               '100%',
//                             height:
//                               '100%',
//                             objectFit:
//                               'cover',
//                           }}
//                           onError={(e) => {
//                             e.currentTarget.src =
//                               buildingImage;
//                           }}
//                         />


//                         <IconButton
//                           size="small"
//                           sx={{
//                             position:
//                               'absolute',
//                             top: 8,
//                             right: 8,
//                             bgcolor:
//                               '#fff',

//                             '&:hover': {
//                               bgcolor:
//                                 '#f0f0f0',
//                             },

//                             p: 0.5,
//                           }}
//                         >

//                           <EditOutlined
//                             sx={{
//                               fontSize: 16,
//                               color:
//                                 '#333',
//                             }}
//                           />

//                         </IconButton>

//                       </Box>

//                     </Box>

//                   </Box>


//                   {/* ==================================================
//                       APPROVED BADGE
//                   =================================================== */}

//                   <Box
//                     sx={{
//                       position:
//                         'relative',
//                       mt: -5,
//                       mb: 2,
//                       display:
//                         'flex',
//                       justifyContent:
//                         'center',
//                     }}
//                   >

//                     <Box
//                       sx={{
//                         backgroundColor:
//                           '#A67C52',
//                         color: '#fff',
//                         px: 3,
//                         py: 0.5,
//                         borderRadius:
//                           10,
//                         fontSize:
//                           '0.75rem',
//                         fontWeight: 600,
//                       }}
//                     >
//                       Approved
//                     </Box>

//                   </Box>


//                   {/* ==================================================
//                       PROPERTY DETAILS
//                   =================================================== */}

//                   <Box
//                     sx={{
//                       px: 1,
//                       pb: 1,
//                     }}
//                   >

//                     {/* Title + Price */}

//                     <Box
//                       display="flex"
//                       justifyContent="space-between"
//                       alignItems="flex-start"
//                       mb={1}
//                     >

//                       <Typography
//                         variant="subtitle1"
//                         fontWeight={700}
//                         sx={{
//                           color: '#222',
//                           flex: 1,
//                           pr: 1,
//                         }}
//                       >
//                         {property.title}
//                       </Typography>


//                       <Typography
//                         variant="subtitle1"
//                         fontWeight={700}
//                         sx={{
//                           color:
//                             '#A67C52',
//                         }}
//                       >
//                         {
//                           property.formattedPrice
//                         }
//                       </Typography>

//                     </Box>


//                     {/* Area + Price per Sqft */}

//                     <Box
//                       display="flex"
//                       justifyContent="space-between"
//                       alignItems="center"
//                       mb={1}
//                     >

//                       <Typography
//                         variant="body2"
//                         sx={{
//                           color: '#555',
//                           fontWeight: 500,
//                         }}
//                       >
//                         {property.area}
//                       </Typography>


//                       {property.pricePerSqft && (

//                         <Typography
//                           variant="body2"
//                           sx={{
//                             color: '#777',
//                           }}
//                         >
//                           {
//                             property.pricePerSqft
//                           }
//                         </Typography>

//                       )}

//                     </Box>


//                     {/* Location */}

//                     <Box
//                       display="flex"
//                       alignItems="center"
//                       mb={2}
//                       gap={0.5}
//                     >

//                       <LocationOn
//                         sx={{
//                           fontSize: 16,
//                           color: '#777',
//                         }}
//                       />

//                       <Typography
//                         variant="body2"
//                         color="text.secondary"
//                         noWrap
//                         sx={{
//                           fontSize:
//                             '0.8rem',
//                         }}
//                       >
//                         {
//                           property.location
//                         }
//                       </Typography>

//                     </Box>


//                     <Divider
//                       sx={{
//                         mb: 1.5,
//                       }}
//                     />


//                     {/* BHK + Possession */}

//                     <Box
//                       display="flex"
//                       justifyContent="space-between"
//                       alignItems="center"
//                     >

//                       <Typography
//                         variant="body2"
//                         fontWeight={600}
//                         sx={{
//                           color: '#333',
//                         }}
//                       >
//                         {property.bhk}
//                       </Typography>


//                       <Typography
//                         variant="body2"
//                         color="text.secondary"
//                       >

//                         Possession:{' '}

//                         <span
//                           style={{
//                             color:
//                               '#A67C52',
//                             fontWeight: 600,
//                           }}
//                         >
//                           {
//                             property.possession
//                           }
//                         </span>

//                       </Typography>

//                     </Box>

//                   </Box>

//                 </Box>


//                 {/* ====================================================
//                     PROPERTY PERFORMANCE
//                 ===================================================== */}

//                 <Box
//                   sx={{
//                     backgroundColor:
//                       '#fff',

//                     borderRadius: 3,

//                     p: 1,

//                     boxShadow:
//                       '0 2px 10px rgba(0,0,0,0.05)',
//                   }}
//                 >

//                   {/* ==================================================
//                       PERFORMANCE HEADER
//                   =================================================== */}

//                   <Box
//                     display="flex"
//                     justifyContent="space-between"
//                     alignItems="center"
//                     mb={2}
//                   >

//                     <Typography
//                       variant="subtitle1"
//                       fontWeight={700}
//                       sx={{
//                         color: '#333',
//                       }}
//                     >
//                       Property Performance
//                     </Typography>


//                     <Box
//                       sx={{
//                         display:
//                           'flex',
//                         alignItems:
//                           'center',
//                         gap: 0.5,
//                         border:
//                           '1px solid #EAEAEA',
//                         borderRadius:
//                           1.5,
//                         px: 1.5,
//                         py: 0.5,
//                         backgroundColor:
//                           '#fff',
//                         cursor:
//                           'pointer',
//                         flexShrink: 0,
//                       }}
//                     >

//                       <CalendarTodayOutlined
//                         sx={{
//                           fontSize: 14,
//                           color:
//                             '#555',
//                         }}
//                       />

//                       <Typography
//                         variant="caption"
//                         sx={{
//                           color:
//                             '#555',
//                           fontWeight: 500,
//                         }}
//                       >
//                         Last 31 days
//                       </Typography>


//                       <KeyboardArrowDownOutlined
//                         sx={{
//                           fontSize: 16,
//                           color:
//                             '#555',
//                         }}
//                       />

//                     </Box>

//                   </Box>


//                   {/* ==================================================
//                       PERFORMANCE METRICS GRID
//                   =================================================== */}

//                   <Box
//                     sx={{
//                       display:
//                         'grid',

//                       gridTemplateColumns:
//                         'repeat(4, minmax(0, 1fr))',

//                       gap: 0.75,
//                     }}
//                   >

//                     {performanceMetrics.map(
//                       (
//                         metric,
//                         index
//                       ) => (

//                         <Box
//                           key={index}
//                           sx={{
//                             border:
//                               '1px solid #F0F0F0',

//                             borderRadius: 2,

//                             p: 0.75,

//                             display:
//                               'flex',

//                             flexDirection:
//                               'column',

//                             gap: 0.5,

//                             minWidth: 0,

//                             height:
//                               '100%',

//                             backgroundColor:
//                               '#fff',

//                             boxShadow:
//                               '0 1px 4px rgba(0,0,0,0.02)',
//                           }}
//                         >

//                           {/* Icon + Label */}

//                           <Box
//                             display="flex"
//                             alignItems="flex-start"
//                             gap={0.5}
//                             sx={{
//                               minWidth: 0,
//                             }}
//                           >

//                             <Box
//                               sx={{
//                                 display:
//                                   'flex',

//                                 alignItems:
//                                   'center',

//                                 justifyContent:
//                                   'center',

//                                 width: 24,

//                                 height: 24,

//                                 borderRadius:
//                                   '50%',

//                                 backgroundColor:
//                                   metric.bgColor,

//                                 color:
//                                   metric.iconColor,

//                                 flexShrink: 0,
//                               }}
//                             >

//                               {metric.icon}

//                             </Box>


//                             <Typography
//                               sx={{
//                                 color:
//                                   '#666',

//                                 fontSize:
//                                   '0.6rem',

//                                 lineHeight:
//                                   1.15,

//                                 minWidth: 0,

//                                 overflowWrap:
//                                   'anywhere',
//                               }}
//                             >

//                               {metric.label}


//                               {metric.subLabel && (

//                                 <span
//                                   style={{
//                                     fontSize:
//                                       '0.55rem',

//                                     color:
//                                       '#999',

//                                     display:
//                                       'block',
//                                   }}
//                                 >
//                                   {
//                                     metric.subLabel
//                                   }
//                                 </span>

//                               )}

//                             </Typography>

//                           </Box>


//                           {/* Dynamic Value */}

//                           <Typography
//                             fontWeight={700}
//                             sx={{
//                               color:
//                                 '#222',

//                               fontSize:
//                                 '0.9rem',

//                               lineHeight:
//                                 1.2,

//                               mt: 'auto',

//                               overflowWrap:
//                                 'anywhere',
//                             }}
//                           >
//                             {
//                               metric.value
//                             }
//                           </Typography>


//                           {/* Current Total */}

//                           <Typography
//                             sx={{
//                               color:
//                                 '#999',

//                               fontSize:
//                                 '0.55rem',

//                               lineHeight:
//                                 1.2,

//                               overflowWrap:
//                                 'anywhere',
//                             }}
//                           >
//                             Current total
//                           </Typography>

//                         </Box>

//                       )
//                     )}

//                   </Box>


//                   {/* ==================================================
//                       DETAILED PERFORMANCE
//                   =================================================== */}

//                   <Box
//                     sx={{
//                       mt: 2,
//                       pt: 2,
//                       borderTop:
//                         '1px solid #EAEAEA',

//                       display:
//                         'flex',

//                       justifyContent:
//                         'center',

//                       alignItems:
//                         'center',

//                       cursor:
//                         'pointer',

//                       color:
//                         '#1976D2',

//                       '&:hover': {
//                         textDecoration:
//                           'underline',
//                       },
//                     }}
//                   >

//                     <BarChartOutlined
//                       sx={{
//                         fontSize: 18,
//                         mr: 0.5,
//                       }}
//                     />

//                     <Typography
//                       variant="body2"
//                       fontWeight={600}
//                     >
//                       View Detailed Performance
//                     </Typography>


//                     <ChevronRight
//                       sx={{
//                         fontSize: 18,
//                         ml: 0.5,
//                       }}
//                     />

//                   </Box>

//                 </Box>

//               </Box>

//             );
//           }
//         )}

//       </Box>


//       {/* ================================================================
//           BOTTOM NAVIGATION
//       ================================================================= */}

//       <BottomNavbar />

//     </Box>
//   );
// };


// export default NewLaunchingProfile;


//===========================================


// import React, { useState, useEffect, useRef } from 'react';
// import {
//   Box,
//   Typography,
//   IconButton,
//   CircularProgress,
//   Divider,
//   CardMedia,
// } from '@mui/material';

// import {
//   EditOutlined,
//   LocationOn,
//   MouseOutlined,
//   PhoneOutlined,
//   HomeOutlined,
//   KeyboardArrowDownOutlined,
//   BarChartOutlined,
//   ChevronRight,
//   CalendarTodayOutlined,
// } from '@mui/icons-material';

// import buildingImage from './../../../../Images/house.jpeg';
// import CustomSearchBar from './../../Lease Module/CustomSearch';
// import BottomNavbar from './../../Post Module/FormsBottomNavbar';
// import { BASE_URL } from './../../../Api/ApiUrls';


// // ---------------------------------------------------------------------
// // API URL
// // ---------------------------------------------------------------------
// const AD_PROPERTIES_URL =
//   'https://landnest.net:81/ad-properties/combined/';


// const NewLaunchingProfile = () => {

//   const [properties, setProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchQuery, setSearchQuery] = useState('');

//   // ---- Image carousel state ----
//   const [activeImageIndex, setActiveImageIndex] = useState({});
//   const [dragOffset, setDragOffset] = useState({});

//   // ---- Swipe refs ----
//   const touchStartX = useRef(null);
//   const touchEndX = useRef(null);
//   const isDragging = useRef(false);
//   const dragPropertyId = useRef(null);


//   // ---------------------------------------------------------------------
//   // Helpers
//   // ---------------------------------------------------------------------

//   const toAbsoluteUrl = (url) => {
//     if (!url) return null;

//     if (url.startsWith('http')) {
//       return url;
//     }

//     if (url.startsWith('/')) {
//       return `${BASE_URL}${url}`;
//     }

//     return `${BASE_URL}/${url}`;
//   };


//   const formatPrice = (price) => {

//     const value = Number(price) || 0;

//     if (!value) {
//       return 'Price on request';
//     }

//     if (value >= 10000000) {
//       return `₹${(value / 10000000).toFixed(2)}Cr`;
//     }

//     if (value >= 100000) {
//       return `₹${(value / 100000).toFixed(2)}L`;
//     }

//     return `₹${value.toLocaleString('en-IN')}`;
//   };


//   const formatDate = (dateStr) => {

//     if (!dateStr) {
//       return null;
//     }

//     const d = new Date(dateStr);

//     if (Number.isNaN(d.getTime())) {
//       return null;
//     }

//     return d.toLocaleDateString('en-IN', {
//       month: 'short',
//       year: 'numeric',
//     });
//   };


//   // ---------------------------------------------------------------------
//   // Data Fetching
//   // ---------------------------------------------------------------------

//   const fetchData = async () => {

//     try {

//       setLoading(true);

//       const response = await fetch(AD_PROPERTIES_URL);

//       const json = await response.json();

//       if (!response.ok || !json.success) {
//         throw new Error(
//           json?.message || 'Failed to fetch ad properties'
//         );
//       }


//       const rawList = json.data || [];


//       const parsed = rawList
//         .slice()
//         .sort(
//           (a, b) =>
//             new Date(b.created_at) -
//             new Date(a.created_at)
//         )
//         .map((item) => {

//           // -------------------------------------------------------------
//           // Images
//           // -------------------------------------------------------------

//           const heroImages = (item.hero_images || [])
//             .slice()
//             .sort(
//               (a, b) =>
//                 (a.order || 0) -
//                 (b.order || 0)
//             )
//             .map((img) =>
//               toAbsoluteUrl(img.image)
//             )
//             .filter(Boolean);


//           let images =
//             heroImages.length > 0
//               ? heroImages
//               : [buildingImage, buildingImage];


//           if (images.length === 1) {
//             images = [
//               images[0],
//               images[0],
//             ];
//           }


//           // -------------------------------------------------------------
//           // Configurations
//           // -------------------------------------------------------------

//           const configs =
//             item.configurations || [];


//           const bhkList = [
//             ...new Set(
//               configs
//                 .map((c) => c.bhk_type)
//                 .filter(Boolean)
//             ),
//           ];


//           const bhk =
//             bhkList.length
//               ? bhkList.join(', ')
//               : item.property_type || '—';


//           // -------------------------------------------------------------
//           // Price Range
//           // -------------------------------------------------------------

//           const configPrices = configs
//             .map((c) => Number(c.price))
//             .filter(
//               (p) =>
//                 !Number.isNaN(p) &&
//                 p > 0
//             );


//           let formattedPrice =
//             'Price on request';


//           if (configPrices.length) {

//             const min =
//               Math.min(...configPrices);

//             const max =
//               Math.max(...configPrices);


//             formattedPrice =
//               min === max
//                 ? formatPrice(min)
//                 : `${formatPrice(min)} - ${formatPrice(max)}`;

//           } else if (item.price) {

//             formattedPrice =
//               formatPrice(item.price);

//           }


//           // -------------------------------------------------------------
//           // Area
//           // -------------------------------------------------------------

//           const areas = configs
//             .map(
//               (c) =>
//                 c.built_up_area ||
//                 c.super_built_up_area ||
//                 c.carpet_area
//             )
//             .filter(
//               (a) =>
//                 a != null &&
//                 a > 0
//             );


//           const area =
//             areas.length > 0
//               ? `${Math.min(...areas)} - ${Math.max(
//                   ...areas
//                 )} sq.ft`
//               : item.site_area
//               ? `${item.site_area} ${
//                   item.units || 'sq.ft'
//                 }`
//               : '—';


//           // -------------------------------------------------------------
//           // Price Per Sqft
//           // -------------------------------------------------------------

//           let pricePerSqft = null;


//           if (
//             configPrices.length &&
//             areas.length
//           ) {

//             const avgPrice =
//               configPrices.reduce(
//                 (sum, price) =>
//                   sum + price,
//                 0
//               ) /
//               configPrices.length;


//             const avgArea =
//               areas.reduce(
//                 (sum, area) =>
//                   sum + area,
//                 0
//               ) /
//               areas.length;


//             if (avgArea > 0) {

//               pricePerSqft =
//                 Math.round(
//                   avgPrice /
//                     avgArea
//                 );

//             }
//           }


//           // -------------------------------------------------------------
//           // Possession
//           // -------------------------------------------------------------

//           const possession =
//             formatDate(
//               item.possession_date
//             ) || '—';


//           // -------------------------------------------------------------
//           // Location
//           // -------------------------------------------------------------

//           const location =
//             item.location ||
//             [
//               item.address,
//               item.city,
//             ]
//               .filter(Boolean)
//               .join(', ') ||
//             'Location not specified';


//           // -------------------------------------------------------------
//           // PERFORMANCE DATA
//           // -------------------------------------------------------------

//           const performance = {

//             totalClicks:
//               Number(
//                 item.total_clicks
//               ) || 0,

//             callClicks:
//               Number(
//                 item.call_clicks
//               ) || 0,

//             requestClicks:
//               Number(
//                 item.request_clicks
//               ) || 0,
//           };


//           // -------------------------------------------------------------
//           // Return Property
//           // -------------------------------------------------------------

//           return {

//             id: item.property_id,

//             title:
//               item.property_name ||
//               'Untitled Property',

//             category:
//               item.category_name ||
//               'Property',

//             location,

//             formattedPrice,

//             pricePerSqft:
//               pricePerSqft
//                 ? `₹${pricePerSqft.toLocaleString(
//                     'en-IN'
//                   )}/sq.ft`
//                 : null,

//             area,

//             bhk,

//             possession,

//             images,

//             performance,

//             propertyData: item,
//           };
//         });


//       setProperties(parsed);

//     } catch (error) {

//       console.error(
//         'Error fetching ad properties:',
//         error
//       );

//       setProperties([]);

//     } finally {

//       setLoading(false);

//     }
//   };


//   // ---------------------------------------------------------------------
//   // Initial API Call
//   // ---------------------------------------------------------------------

//   useEffect(() => {
//     fetchData();
//   }, []);


//   // ---------------------------------------------------------------------
//   // Filter Properties
//   // ---------------------------------------------------------------------

//   const filteredProperties =
//     properties.filter((property) => {

//       const search =
//         searchQuery.toLowerCase();

//       return (
//         property.title
//           .toLowerCase()
//           .includes(search) ||

//         property.location
//           .toLowerCase()
//           .includes(search) ||

//         property.category
//           .toLowerCase()
//           .includes(search)
//       );
//     });


//   // ---------------------------------------------------------------------
//   // Swipe / Drag handlers
//   // ---------------------------------------------------------------------

//   const handleDragStart = (propertyId, e) => {
//     const clientX = e.touches ? e.touches[0].clientX : e.clientX;
//     touchStartX.current = clientX;
//     touchEndX.current = clientX;
//     isDragging.current = true;
//     dragPropertyId.current = propertyId;
//   };

//   const handleDragMove = (propertyId, e) => {
//     if (!isDragging.current || dragPropertyId.current !== propertyId) return;
//     if (touchStartX.current === null) return;

//     const clientX = e.touches ? e.touches[0].clientX : e.clientX;
//     touchEndX.current = clientX;

//     const diff = clientX - touchStartX.current;

//     setDragOffset((prev) => ({
//       ...prev,
//       [propertyId]: diff,
//     }));
//   };

//   const handleDragEnd = (propertyId, totalImages) => {
//     if (!isDragging.current || dragPropertyId.current !== propertyId) return;
//     if (touchStartX.current === null) {
//       isDragging.current = false;
//       dragPropertyId.current = null;
//       setDragOffset((prev) => ({ ...prev, [propertyId]: 0 }));
//       return;
//     }

//     const diff = (touchEndX.current || 0) - touchStartX.current;
//     const threshold = 50;

//     if (Math.abs(diff) > threshold) {
//       if (diff < 0) {
//         setActiveImageIndex((prev) => ({
//           ...prev,
//           [propertyId]: ((prev[propertyId] || 0) + 1) % totalImages,
//         }));
//       } else {
//         setActiveImageIndex((prev) => ({
//           ...prev,
//           [propertyId]:
//             ((prev[propertyId] || 0) - 1 + totalImages) % totalImages,
//         }));
//       }
//     }

//     touchStartX.current = null;
//     touchEndX.current = null;
//     isDragging.current = false;
//     dragPropertyId.current = null;

//     setDragOffset((prev) => ({
//       ...prev,
//       [propertyId]: 0,
//     }));
//   };

//   const handleNextImage = (propertyId, totalImages) => {
//     setActiveImageIndex((prev) => ({
//       ...prev,
//       [propertyId]: ((prev[propertyId] || 0) + 1) % totalImages,
//     }));
//   };


//   // ---------------------------------------------------------------------
//   // Loading
//   // ---------------------------------------------------------------------

//   if (loading) {

//     return (
//       <Box
//         sx={{
//           backgroundColor: '#F8F9FA',
//           minHeight: '100vh',
//           display: 'flex',
//           flexDirection: 'column',
//           justifyContent: 'center',
//           alignItems: 'center',
//           gap: 3,
//         }}
//       >

//         <CircularProgress
//           size={40}
//           sx={{
//             color: '#4CAF50',
//           }}
//         />

//         <Typography
//           variant="h7"
//           sx={{
//             color: '#000000',
//             fontWeight: 600,
//           }}
//         >
//           Loading New Launching Profiles...
//         </Typography>

//       </Box>
//     );
//   }


//   // ---------------------------------------------------------------------
//   // Main UI
//   // ---------------------------------------------------------------------

//   return (

//     <Box
//       sx={{
//         backgroundColor: 'rgba(239, 231, 221, 0.8)',
//         minHeight: '100vh',
//         pb: 10,
//       }}
//     >

//       {/* ================================================================
//           STICKY SEARCH BAR
//       ================================================================= */}

//       <Box
//         sx={{
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           right: 0,
//           zIndex: 1200,
//           px: 1,
//           py: 1,
//           backgroundColor: '#F8F9FA',
//         }}
//       >

//         <CustomSearchBar
//           value={searchQuery}
//           onChange={(e) =>
//             setSearchQuery(
//               e.target.value
//             )
//           }
//         />

//       </Box>


//       {/* ================================================================
//           CONTENT WRAPPER
//       ================================================================= */}

//       <Box
//         sx={{
//           pt: {
//             xs: '50px',
//             sm: '100px',
//           },
//         }}
//       >

//         {/* ==============================================================
//             PAGE HEADER
//         =============================================================== */}

//         <Box
//           sx={{
//             backgroundColor: '#fff',
//             px: 1,
//             py: 1,
//             borderBottom:
//               '1px solid #EAEAEA',
//             mb: 1,
//           }}
//         >

//           <Typography
//             variant="h6"
//             sx={{
//               fontWeight: 600,
//               color: '#000000',
//               fontSize: '1.1rem',
//             }}
//           >
//             New Launching Profile
//           </Typography>

//         </Box>


//         {/* ==============================================================
//             NO DATA
//         =============================================================== */}

//         {filteredProperties.length === 0 && (

//           <Box
//             sx={{
//               p: 3,
//               textAlign: 'center',
//             }}
//           >

//             <Typography
//               variant="body2"
//               color="text.secondary"
//             >
//               No new launching properties
//               found matching your search.
//             </Typography>

//           </Box>

//         )}


//         {/* ==============================================================
//             PROPERTY LIST
//         =============================================================== */}

//         {filteredProperties.map(
//           (property) => {

//             // ----------------------------------------------------------
//             // Image carousel variables
//             // ----------------------------------------------------------

//             const currentIndex =
//               activeImageIndex[property.id] || 0;

//             const totalImages =
//               property.images.length;

//             const nextIndex =
//               (currentIndex + 1) % totalImages;

//             const offset =
//               dragOffset[property.id] || 0;


//             // ----------------------------------------------------------
//             // Dynamic Performance Metrics
//             // ----------------------------------------------------------

//             const performanceMetrics = [

//               {
//                 label: 'Total Clicks',

//                 value:
//                   property.performance.totalClicks.toLocaleString(
//                     'en-IN'
//                   ),

//                 icon: (
//                   <MouseOutlined
//                     sx={{
//                       fontSize: 15,
//                     }}
//                   />
//                 ),

//                 iconColor:
//                   '#4A90E2',

//                 bgColor:
//                   '#EAF4FF',
//               },


//               {
//                 label: 'Call Clicks',

//                 value:
//                   property.performance.callClicks.toLocaleString(
//                     'en-IN'
//                   ),

//                 icon: (
//                   <PhoneOutlined
//                     sx={{
//                       fontSize: 15,
//                     }}
//                   />
//                 ),

//                 iconColor:
//                   '#4CAF50',

//                 bgColor:
//                   '#E8F5E9',
//               },


//               {
//                 label:
//                   'Request Property Clicks',

//                 value:
//                   property.performance.requestClicks.toLocaleString(
//                     'en-IN'
//                   ),

//                 icon: (
//                   <HomeOutlined
//                     sx={{
//                       fontSize: 15,
//                     }}
//                   />
//                 ),

//                 iconColor:
//                   '#4A90E2',

//                 bgColor:
//                   '#EAF4FF',
//               },

//             ];


//             return (

//               <Box
//                 key={property.id}
//                 sx={{
//                   p: 1,
//                 }}
//               >

//                 {/* ====================================================
//                     MAIN PROPERTY CARD
//                 ===================================================== */}

//                 <Box
//                   sx={{
//                     backgroundColor:
//                       '#fff',

//                     borderRadius: 3,

//                     overflow: 'hidden',

//                     boxShadow:
//                       '0 2px 10px rgba(0,0,0,0.05)',

//                     mb: 3,
//                   }}
//                 >

//                   {/* ==================================================
//                       IMAGES — SLIDING CAROUSEL (MAIN + SIDE PREVIEW)
//                   =================================================== */}

//                   <Box
//                     sx={{
//                       display: 'flex',
//                       gap: '6px',
//                       p: 1.5,
//                       height: 240,
//                     }}
//                   >

//                     {/* Main Image Carousel (Swipeable) */}
//                     <Box
//                       onTouchStart={(e) =>
//                         handleDragStart(property.id, e)
//                       }
//                       onTouchMove={(e) =>
//                         handleDragMove(property.id, e)
//                       }
//                       onTouchEnd={() =>
//                         handleDragEnd(property.id, totalImages)
//                       }
//                       onMouseDown={(e) =>
//                         handleDragStart(property.id, e)
//                       }
//                       onMouseMove={(e) =>
//                         handleDragMove(property.id, e)
//                       }
//                       onMouseUp={() =>
//                         handleDragEnd(property.id, totalImages)
//                       }
//                       onMouseLeave={() => {
//                         if (
//                           isDragging.current &&
//                           dragPropertyId.current === property.id
//                         ) {
//                           handleDragEnd(property.id, totalImages);
//                         }
//                       }}
//                       sx={{
//                         flex: 2.4,
//                         position: 'relative',
//                         borderRadius: '14px',
//                         overflow: 'hidden',
//                         cursor: isDragging.current
//                           ? 'grabbing'
//                           : 'grab',
//                         userSelect: 'none',
//                         touchAction: 'pan-y',
//                       }}
//                     >

//                       {/* Sliding track */}
//                       <Box
//                         sx={{
//                           display: 'flex',
//                           width: '100%',
//                           height: '100%',
//                           transform: `translateX(calc(-${currentIndex * 100}% + ${offset}px))`,
//                           transition: isDragging.current
//                             ? 'none'
//                             : 'transform 0.45s ease-in-out',
//                           willChange: 'transform',
//                         }}
//                       >

//                         {property.images.map(
//                           (img, idx) => (

//                             <Box
//                               key={idx}
//                               component="img"
//                               src={img || buildingImage}
//                               alt={`${property.title}-${idx}`}
//                               draggable={false}
//                               onError={(e) => {
//                                 e.currentTarget.src =
//                                   buildingImage;
//                               }}
//                               sx={{
//                                 minWidth: '100%',
//                                 width: '100%',
//                                 height: '100%',
//                                 objectFit: 'cover',
//                                 flexShrink: 0,
//                                 display: 'block',
//                                 pointerEvents: 'none',
//                               }}
//                             />

//                           )
//                         )}

//                       </Box>


//                       {/* ==============================================
//                           APPROVED BADGE — TOP RIGHT
//                       =============================================== */}

//                       <Box
//                         sx={{
//                           position: 'absolute',
//                           top: 10,
//                           right: 10,
//                           backgroundColor:
//                             '#A67C52',
//                           color: '#fff',
//                           px: 1.75,
//                           py: 0.4,
//                           borderRadius: 10,
//                           fontSize: '0.7rem',
//                           fontWeight: 600,
//                           boxShadow:
//                             '0 2px 6px rgba(0,0,0,0.2)',
//                           pointerEvents: 'none',
//                           zIndex: 2,
//                         }}
//                       >
//                         Approved
//                       </Box>


//                       {/* Dot indicators */}
//                       {totalImages > 1 && (

//                         <Box
//                           sx={{
//                             position: 'absolute',
//                             bottom: 8,
//                             left: '50%',
//                             transform:
//                               'translateX(-50%)',
//                             display: 'flex',
//                             gap: '4px',
//                             px: 1,
//                             py: 0.4,
//                             borderRadius: '10px',
//                             bgcolor:
//                               'rgba(0,0,0,0.35)',
//                           }}
//                         >

//                           {property.images.map(
//                             (_, idx) => (

//                               <Box
//                                 key={idx}
//                                 sx={{
//                                   width: 5,
//                                   height: 5,
//                                   borderRadius: '50%',
//                                   bgcolor:
//                                     currentIndex === idx
//                                       ? '#FFFFFF'
//                                       : 'rgba(255,255,255,0.5)',
//                                   transition:
//                                     'background 0.2s',
//                                 }}
//                               />

//                             )
//                           )}

//                         </Box>

//                       )}

//                     </Box>


//                     {/* Side Preview Image (tap to advance) */}
//                     <Box
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleNextImage(
//                           property.id,
//                           totalImages
//                         );
//                       }}
//                       sx={{
//                         flex: 1,
//                         position: 'relative',
//                         borderRadius: '14px',
//                         overflow: 'hidden',
//                         cursor: 'pointer',
//                       }}
//                     >

//                       <CardMedia
//                         component="img"
//                         image={
//                           property.images[nextIndex] ||
//                           property.images[0] ||
//                           buildingImage
//                         }
//                         alt={property.title}
//                         sx={{
//                           width: '100%',
//                           height: '100%',
//                           objectFit: 'cover',
//                         }}
//                         onError={(e) => {
//                           e.currentTarget.src =
//                             buildingImage;
//                         }}
//                       />


//                       <IconButton
//                         size="small"
//                         sx={{
//                           position:
//                             'absolute',
//                           top: 8,
//                           right: 8,
//                           bgcolor:
//                             '#fff',

//                           '&:hover': {
//                             bgcolor:
//                               '#f0f0f0',
//                           },

//                           p: 0.5,
//                         }}
//                       >

//                         <EditOutlined
//                           sx={{
//                             fontSize: 16,
//                             color:
//                               '#333',
//                           }}
//                         />

//                       </IconButton>

//                     </Box>

//                   </Box>


//                   {/* ==================================================
//                       PROPERTY DETAILS
//                   =================================================== */}

//                   <Box
//                     sx={{
//                       px: 1,
//                       pb: 1,
//                     }}
//                   >

//                     {/* Title + Price */}

//                     <Box
//                       display="flex"
//                       justifyContent="space-between"
//                       alignItems="flex-start"
//                       mb={1}
//                     >

//                       <Typography
//                         variant="subtitle1"
//                         fontWeight={700}
//                         sx={{
//                           color: '#222',
//                           flex: 1,
//                           pr: 1,
//                         }}
//                       >
//                         {property.title}
//                       </Typography>


//                       <Typography
//                         variant="subtitle1"
//                         fontWeight={700}
//                         sx={{
//                           color:
//                             '#A67C52',
//                         }}
//                       >
//                         {
//                           property.formattedPrice
//                         }
//                       </Typography>

//                     </Box>


//                     {/* Area + Price per Sqft */}

//                     <Box
//                       display="flex"
//                       justifyContent="space-between"
//                       alignItems="center"
//                       mb={1}
//                     >

//                       <Typography
//                         variant="body2"
//                         sx={{
//                           color: '#555',
//                           fontWeight: 500,
//                         }}
//                       >
//                         {property.area}
//                       </Typography>


//                       {property.pricePerSqft && (

//                         <Typography
//                           variant="body2"
//                           sx={{
//                             color: '#777',
//                           }}
//                         >
//                           {
//                             property.pricePerSqft
//                           }
//                         </Typography>

//                       )}

//                     </Box>


//                     {/* Location */}

//                     <Box
//                       display="flex"
//                       alignItems="center"
//                       mb={2}
//                       gap={0.5}
//                     >

//                       <LocationOn
//                         sx={{
//                           fontSize: 16,
//                           color: '#777',
//                         }}
//                       />

//                       <Typography
//                         variant="body2"
//                         color="text.secondary"
//                         noWrap
//                         sx={{
//                           fontSize:
//                             '0.8rem',
//                         }}
//                       >
//                         {
//                           property.location
//                         }
//                       </Typography>

//                     </Box>


//                     <Divider
//                       sx={{
//                         mb: 1.5,
//                       }}
//                     />


//                     {/* BHK + Possession */}

//                     <Box
//                       display="flex"
//                       justifyContent="space-between"
//                       alignItems="center"
//                     >

//                       <Typography
//                         variant="body2"
//                         fontWeight={600}
//                         sx={{
//                           color: '#333',
//                         }}
//                       >
//                         {property.bhk}
//                       </Typography>


//                       <Typography
//                         variant="body2"
//                         color="text.secondary"
//                       >

//                         Possession:{' '}

//                         <span
//                           style={{
//                             color:
//                               '#A67C52',
//                             fontWeight: 600,
//                           }}
//                         >
//                           {
//                             property.possession
//                           }
//                         </span>

//                       </Typography>

//                     </Box>

//                   </Box>

//                 </Box>


//                 {/* ====================================================
//                     PROPERTY PERFORMANCE
//                 ===================================================== */}

//                 <Box
//                   sx={{
//                     backgroundColor:
//                       '#fff',

//                     borderRadius: 3,

//                     p: 1,

//                     boxShadow:
//                       '0 2px 10px rgba(0,0,0,0.05)',
//                   }}
//                 >

//                   {/* ==================================================
//                       PERFORMANCE HEADER
//                   =================================================== */}

//                   <Box
//                     display="flex"
//                     justifyContent="space-between"
//                     alignItems="center"
//                     mb={2}
//                   >

//                     <Typography
//                       variant="subtitle1"
//                       fontWeight={700}
//                       sx={{
//                         color: '#333',
//                       }}
//                     >
//                       Property Performance
//                     </Typography>


//                     <Box
//                       sx={{
//                         display:
//                           'flex',
//                         alignItems:
//                           'center',
//                         gap: 0.5,
//                         border:
//                           '1px solid #EAEAEA',
//                         borderRadius:
//                           1.5,
//                         px: 1.5,
//                         py: 0.5,
//                         backgroundColor:
//                           '#fff',
//                         cursor:
//                           'pointer',
//                         flexShrink: 0,
//                       }}
//                     >

//                       <CalendarTodayOutlined
//                         sx={{
//                           fontSize: 14,
//                           color:
//                             '#555',
//                         }}
//                       />

//                       <Typography
//                         variant="caption"
//                         sx={{
//                           color:
//                             '#555',
//                           fontWeight: 500,
//                         }}
//                       >
//                         Last 31 days
//                       </Typography>


//                       <KeyboardArrowDownOutlined
//                         sx={{
//                           fontSize: 16,
//                           color:
//                             '#555',
//                         }}
//                       />

//                     </Box>

//                   </Box>


//                   {/* ==================================================
//                       PERFORMANCE METRICS GRID
//                   =================================================== */}

//                   <Box
//                     sx={{
//                       display:
//                         'grid',

//                       gridTemplateColumns:
//                         'repeat(3, minmax(0, 1fr))',

//                       gap: 0.75,
//                     }}
//                   >

//                     {performanceMetrics.map(
//                       (
//                         metric,
//                         index
//                       ) => (

//                         <Box
//                           key={index}
//                           sx={{
//                             border:
//                               '1px solid #F0F0F0',

//                             borderRadius: 2,

//                             p: 0.75,

//                             display:
//                               'flex',

//                             flexDirection:
//                               'column',

//                             gap: 0.5,

//                             minWidth: 0,

//                             height:
//                               '100%',

//                             backgroundColor:
//                               '#fff',

//                             boxShadow:
//                               '0 1px 4px rgba(0,0,0,0.02)',
//                           }}
//                         >

//                           {/* Icon + Label */}

//                           <Box
//                             display="flex"
//                             alignItems="flex-start"
//                             gap={0.5}
//                             sx={{
//                               minWidth: 0,
//                             }}
//                           >

//                             <Box
//                               sx={{
//                                 display:
//                                   'flex',

//                                 alignItems:
//                                   'center',

//                                 justifyContent:
//                                   'center',

//                                 width: 24,

//                                 height: 24,

//                                 borderRadius:
//                                   '50%',

//                                 backgroundColor:
//                                   metric.bgColor,

//                                 color:
//                                   metric.iconColor,

//                                 flexShrink: 0,
//                               }}
//                             >

//                               {metric.icon}

//                             </Box>


//                             <Typography
//                               sx={{
//                                 color:
//                                   '#666',

//                                 fontSize:
//                                   '0.6rem',

//                                 lineHeight:
//                                   1.15,

//                                 minWidth: 0,

//                                 overflowWrap:
//                                   'anywhere',
//                               }}
//                             >

//                               {metric.label}


//                               {metric.subLabel && (

//                                 <span
//                                   style={{
//                                     fontSize:
//                                       '0.55rem',

//                                     color:
//                                       '#999',

//                                     display:
//                                       'block',
//                                   }}
//                                 >
//                                   {
//                                     metric.subLabel
//                                   }
//                                 </span>

//                               )}

//                             </Typography>

//                           </Box>


//                           {/* Dynamic Value */}

//                           <Typography
//                             fontWeight={700}
//                             sx={{
//                               color:
//                                 '#222',

//                               fontSize:
//                                 '0.9rem',

//                               lineHeight:
//                                 1.2,

//                               mt: 'auto',

//                               overflowWrap:
//                                 'anywhere',
//                             }}
//                           >
//                             {
//                               metric.value
//                             }
//                           </Typography>


//                           {/* Current Total */}

//                           <Typography
//                             sx={{
//                               color:
//                                 '#999',

//                               fontSize:
//                                 '0.55rem',

//                               lineHeight:
//                                 1.2,

//                               overflowWrap:
//                                 'anywhere',
//                             }}
//                           >
//                             Current total
//                           </Typography>

//                         </Box>

//                       )
//                     )}

//                   </Box>


//                   {/* ==================================================
//                       DETAILED PERFORMANCE
//                   =================================================== */}

//                   <Box
//                     sx={{
//                       mt: 2,
//                       pt: 2,
//                       borderTop:
//                         '1px solid #EAEAEA',

//                       display:
//                         'flex',

//                       justifyContent:
//                         'center',

//                       alignItems:
//                         'center',

//                       cursor:
//                         'pointer',

//                       color:
//                         '#1976D2',

//                       '&:hover': {
//                         textDecoration:
//                           'underline',
//                       },
//                     }}
//                   >

//                     <BarChartOutlined
//                       sx={{
//                         fontSize: 18,
//                         mr: 0.5,
//                       }}
//                     />

//                     <Typography
//                       variant="body2"
//                       fontWeight={600}
//                     >
//                       View Detailed Performance
//                     </Typography>


//                     <ChevronRight
//                       sx={{
//                         fontSize: 18,
//                         ml: 0.5,
//                       }}
//                     />

//                   </Box>

//                 </Box>

//               </Box>

//             );
//           }
//         )}

//       </Box>


//       {/* ================================================================
//           BOTTOM NAVIGATION
//       ================================================================= */}

//       <BottomNavbar />

//     </Box>
//   );
// };


// export default NewLaunchingProfile;


import React, { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  IconButton,
  CircularProgress,
  Divider,
  CardMedia,
  Button,
  Menu,
  MenuItem,
} from '@mui/material';

import {
  EditOutlined,
  LocationOn,
  MouseOutlined,
  PhoneOutlined,
  HomeOutlined,
  KeyboardArrowDownOutlined,
  BarChartOutlined,
  ChevronRight,
  CalendarTodayOutlined,
  FavoriteBorder,
  Share as ShareIcon,
  MoreVert,
  DeleteOutline,
} from '@mui/icons-material';

import buildingImage from './../../../../Images/house.jpeg';
import CustomSearchBar from './../../Lease Module/CustomSearch';
import BottomNavbar from './../../Post Module/FormsBottomNavbar';
import { AuthContext } from './../../../AuthContext/AuthContext';
import { BASE_URL } from './../../../Api/ApiUrls';

import ShareCopySuccessAlert from '../../Alertpage/ShareAlert/ShareCopySuccessAlert';
import ShareCopyFailureAlert from '../../Alertpage/ShareAlert/ShareCopyFailureAlert';
import DeleteFailureAlert from '../../Alertpage/DeleteAlert/DeleteFailureAlert';
import DeleteSuccessAlert from '../../Alertpage/DeleteAlert/DeleteSuccessAlert';
import DeleteConfirmAlert from '../../Alertpage/DeleteAlert/DeleteConfirmAlert';


// ---------------------------------------------------------------------
// API URLs
// ---------------------------------------------------------------------
const AD_PROPERTIES_BASE_URL = 'https://landnest.net:81/ad-properties';


const NewLaunchingProfile = () => {

  const navigate = useNavigate();
  const { userId } = useContext(AuthContext);

  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');

  // ---- Image carousel state ----
  const [activeImageIndex, setActiveImageIndex] = useState({});
  const [dragOffset, setDragOffset] = useState({});

  // ---- Swipe refs ----
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);
  const isDragging = useRef(false);
  const dragPropertyId = useRef(null);
  // true when the user actually dragged (so we don't navigate on drag-release)
  const didDrag = useRef(false);

  // ---- Menu state ----
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuPropertyId, setMenuPropertyId] = useState(null);

  // ---- Alert states ----
  const [alertMessage, setAlertMessage] = useState('');
  const [showShareSuccess, setShowShareSuccess] = useState(false);
  const [showShareFailure, setShowShareFailure] = useState(false);
  const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
  const [showDeleteFailure, setShowDeleteFailure] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [menuPropertyIdToDelete, setMenuPropertyIdToDelete] = useState(null);


  // ---------------------------------------------------------------------
  // Helpers
  // ---------------------------------------------------------------------

  const toAbsoluteUrl = (url) => {
    if (!url) return null;
    if (url.startsWith('http')) return url;
    if (url.startsWith('/')) return `${BASE_URL}${url}`;
    return `${BASE_URL}/${url}`;
  };


  const formatPrice = (price) => {
    const value = Number(price) || 0;
    if (!value) return 'Price on request';
    if (value >= 10000000) return `₹${(value / 10000000).toFixed(2)}Cr`;
    if (value >= 100000) return `₹${(value / 100000).toFixed(2)}L`;
    return `₹${value.toLocaleString('en-IN')}`;
  };


  const formatDate = (dateStr) => {
    if (!dateStr) return null;
    const d = new Date(dateStr);
    if (Number.isNaN(d.getTime())) return null;
    return d.toLocaleDateString('en-IN', {
      month: 'short',
      year: 'numeric',
    });
  };


  // ---------------------------------------------------------------------
  // Data Fetching
  // ---------------------------------------------------------------------

  const fetchData = async () => {
    try {
      setLoading(true);

      const response = await fetch(
        `${AD_PROPERTIES_BASE_URL}/performance/?user_id=${userId}`
      );

      const json = await response.json();

      if (!response.ok || !json.success) {
        throw new Error(json?.message || 'Failed to fetch ad properties');
      }

      const rawList = json.data || [];

      const parsed = rawList
        .slice()
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
        .map((item) => {

          // Images
          const heroImages = (item.hero_images || [])
            .slice()
            .sort((a, b) => (a.order || 0) - (b.order || 0))
            .map((img) => toAbsoluteUrl(img.image))
            .filter(Boolean);

          let images =
            heroImages.length > 0
              ? heroImages
              : [buildingImage, buildingImage];

          if (images.length === 1) {
            images = [images[0], images[0]];
          }

          // Configurations
          const configs = item.configurations || [];

          const bhkList = [
            ...new Set(configs.map((c) => c.bhk_type).filter(Boolean)),
          ];

          const bhk = bhkList.length
            ? bhkList.join(', ')
            : item.property_type || '—';

          // Price
          const configPrices = configs
            .map((c) => Number(c.price))
            .filter((p) => !Number.isNaN(p) && p > 0);

          let formattedPrice = 'Price on request';

          if (configPrices.length) {
            const min = Math.min(...configPrices);
            const max = Math.max(...configPrices);

            formattedPrice =
              min === max
                ? formatPrice(min)
                : `${formatPrice(min)} - ${formatPrice(max)}`;
          } else if (item.price) {
            formattedPrice = formatPrice(item.price);
          }

          // Area
          const areas = configs
            .map(
              (c) => c.built_up_area || c.super_built_up_area || c.carpet_area
            )
            .filter((a) => a != null && a > 0);

          const area =
            areas.length > 0
              ? `${Math.min(...areas)} - ${Math.max(...areas)} sq.ft`
              : item.site_area
              ? `${item.site_area} ${item.units || 'sq.ft'}`
              : '—';

          // Price per sqft
          let pricePerSqft = null;

          if (configPrices.length && areas.length) {
            const avgPrice =
              configPrices.reduce((s, p) => s + p, 0) / configPrices.length;

            const avgArea = areas.reduce((s, a) => s + a, 0) / areas.length;

            if (avgArea > 0) {
              pricePerSqft = Math.round(avgPrice / avgArea);
            }
          }

          // Possession
          const possession = formatDate(item.possession_date) || '—';

          // Location
          const propertyLocation =
            item.location ||
            [item.address, item.city].filter(Boolean).join(', ') ||
            'Location not specified';

          // Performance
          const performance = {
            totalClicks: Number(item.total_clicks) || 0,
            callClicks: Number(item.call_clicks) || 0,
            requestClicks: Number(item.request_clicks) || 0,
          };

          return {
            id: item.property_id,
            title: item.property_name || 'Untitled Property',
            category: item.category_name || 'Property',
            location: propertyLocation,
            formattedPrice,
            pricePerSqft: pricePerSqft
              ? `₹${pricePerSqft.toLocaleString('en-IN')}/sq.ft`
              : null,
            area,
            bhk,
            possession,
            images,
            performance,
            propertyData: item,
          };
        });

      setProperties(parsed);

      console.log(
        'New Launching / Premium / Future Launching count:',
        json.count
      );
    } catch (error) {
      console.error('Error fetching ad properties:', error);
      setProperties([]);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (!userId) return;
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);


  // ---------------------------------------------------------------------
  // Filter
  // ---------------------------------------------------------------------

  const filteredProperties = properties.filter((property) => {
    const search = searchQuery.toLowerCase();
    return (
      property.title.toLowerCase().includes(search) ||
      property.location.toLowerCase().includes(search) ||
      property.category.toLowerCase().includes(search)
    );
  });


  // ---------------------------------------------------------------------
  // Navigation handlers
  // ---------------------------------------------------------------------

  // 1. Click on property card -> /new-launching-properties/:id
  const handlePropertyClick = (propertyId) => {
    // ignore the click that fires at the end of a swipe/drag
    if (didDrag.current) {
      didDrag.current = false;
      return;
    }
    navigate(`/new-launching-properties/${propertyId}`);
  };

  // 3. Performance metric clicks
  const handleMetricClick = (e, path, propertyId) => {
    e.stopPropagation();
    navigate(`${path}/${propertyId}`);
  };


  // ---------------------------------------------------------------------
  // Swipe / Drag handlers
  // ---------------------------------------------------------------------

  const handleDragStart = (propertyId, e) => {
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    touchStartX.current = clientX;
    touchEndX.current = clientX;
    isDragging.current = true;
    dragPropertyId.current = propertyId;
    didDrag.current = false;
  };

  const handleDragMove = (propertyId, e) => {
    if (!isDragging.current || dragPropertyId.current !== propertyId) return;
    if (touchStartX.current === null) return;

    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    touchEndX.current = clientX;
    const diff = clientX - touchStartX.current;

    if (Math.abs(diff) > 5) {
      didDrag.current = true;
    }

    setDragOffset((prev) => ({ ...prev, [propertyId]: diff }));
  };

  const handleDragEnd = (propertyId, totalImages) => {
    if (!isDragging.current || dragPropertyId.current !== propertyId) return;
    if (touchStartX.current === null) {
      isDragging.current = false;
      dragPropertyId.current = null;
      setDragOffset((prev) => ({ ...prev, [propertyId]: 0 }));
      return;
    }

    const diff = (touchEndX.current || 0) - touchStartX.current;
    const threshold = 50;

    if (Math.abs(diff) > threshold) {
      if (diff < 0) {
        setActiveImageIndex((prev) => ({
          ...prev,
          [propertyId]: ((prev[propertyId] || 0) + 1) % totalImages,
        }));
      } else {
        setActiveImageIndex((prev) => ({
          ...prev,
          [propertyId]:
            ((prev[propertyId] || 0) - 1 + totalImages) % totalImages,
        }));
      }
    }

    touchStartX.current = null;
    touchEndX.current = null;
    isDragging.current = false;
    dragPropertyId.current = null;
    setDragOffset((prev) => ({ ...prev, [propertyId]: 0 }));
  };

  const handleNextImage = (propertyId, totalImages) => {
    setActiveImageIndex((prev) => ({
      ...prev,
      [propertyId]: ((prev[propertyId] || 0) + 1) % totalImages,
    }));
  };


  // ---------------------------------------------------------------------
  // Menu handlers
  // ---------------------------------------------------------------------

  const handleMenuOpen = (event, propertyId) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setMenuPropertyId(propertyId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuPropertyId(null);
  };


  // ---------------------------------------------------------------------
  // Share handler  (2. copies /new-launching-properties/:id)
  // ---------------------------------------------------------------------

  const handleShare = async (event, property) => {
    event.stopPropagation();
    const propertyUrl = `${window.location.origin}/new-launching-properties/${property.id}`;
    try {
      await navigator.clipboard.writeText(propertyUrl);
      setAlertMessage('Property link copied successfully!');
      setShowShareSuccess(true);
      setShowShareFailure(false);
    } catch (error) {
      setAlertMessage('Failed to copy property link');
      setShowShareFailure(true);
      setShowShareSuccess(false);
    }
  };


  // ---------------------------------------------------------------------
  // Wishlist handler
  // ---------------------------------------------------------------------

  const handleWishlistClick = (propertyId, e) => {
    e.stopPropagation();
    navigate(`/projects-wishlist-users/${propertyId}`);
  };


  // ---------------------------------------------------------------------
  // Edit handler
  // ---------------------------------------------------------------------

  const handleEdit = (propertyId, e) => {
    if (e) e.stopPropagation();
    navigate(`/user-edit-buy/${propertyId}`);
  };


  // ---------------------------------------------------------------------
  // Delete handler  -> DELETE https://landnest.net:81/ad-properties/:id/
  // ---------------------------------------------------------------------

  const handleDelete = async () => {
    if (!menuPropertyIdToDelete) return;
    try {
      const response = await fetch(
        `${AD_PROPERTIES_BASE_URL}/${menuPropertyIdToDelete}/`,
        { method: 'DELETE' }
      );

      if (response.ok) {
        setProperties((prev) =>
          prev.filter((p) => p.id !== menuPropertyIdToDelete)
        );
        setAlertMessage(
          `Property ID ${menuPropertyIdToDelete} deleted successfully.`
        );
        setShowDeleteSuccess(true);
      } else {
        const errorData = await response.json().catch(() => ({}));
        setAlertMessage(
          `Failed to delete property ID ${menuPropertyIdToDelete}. Reason: ${
            errorData.detail || errorData.message || 'Unknown error'
          }`
        );
        setShowDeleteFailure(true);
      }
    } catch (error) {
      console.error('Error deleting property:', error);
      setAlertMessage('An error occurred while trying to delete the property.');
      setShowDeleteFailure(true);
    } finally {
      setMenuPropertyIdToDelete(null);
      handleMenuClose();
    }
  };


  // ---------------------------------------------------------------------
  // Loading
  // ---------------------------------------------------------------------

  if (loading) {
    return (
      <Box
        sx={{
          backgroundColor: '#F8F9FA',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 3,
        }}
      >
        <CircularProgress size={40} sx={{ color: '#4CAF50' }} />
        <Typography variant="h7" sx={{ color: '#000000', fontWeight: 600 }}>
          Loading New Launching Profiles...
        </Typography>
      </Box>
    );
  }


  // ---------------------------------------------------------------------
  // Main UI
  // ---------------------------------------------------------------------

  return (
    <Box
      sx={{
        backgroundColor: 'rgba(239, 231, 221, 0.8)',
        minHeight: '100vh',
        pb: 10,
      }}
    >

      {/* STICKY SEARCH BAR */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1200,
          px: 1,
          py: 1,
          backgroundColor: '#F8F9FA',
        }}
      >
        <CustomSearchBar
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </Box>


      {/* CONTENT */}
      <Box sx={{ pt: { xs: '50px', sm: '100px' } }}>

        {/* PAGE HEADER */}
        <Box
          sx={{
            backgroundColor: '#fff',
            px: 1,
            py: 1,
            borderBottom: '1px solid #EAEAEA',
            mb: 1,
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: 600, color: '#000000', fontSize: '1.1rem' }}
          >
            New Launching Profile
          </Typography>
        </Box>


        {/* NO DATA */}
        {filteredProperties.length === 0 && (
          <Box sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              No new launching properties found matching your search.
            </Typography>
          </Box>
        )}


        {/* PROPERTY LIST */}
        {filteredProperties.map((property) => {

          const currentIndex = activeImageIndex[property.id] || 0;
          const totalImages = property.images.length;
          const nextIndex = (currentIndex + 1) % totalImages;
          const offset = dragOffset[property.id] || 0;

          const performanceMetrics = [
            {
              label: 'Total Clicks',
              value: property.performance.totalClicks.toLocaleString('en-IN'),
              icon: <MouseOutlined sx={{ fontSize: 15 }} />,
              iconColor: '#4A90E2',
              bgColor: '#EAF4FF',
              path: '/project-total-clicks',
            },
            {
              label: 'Call Clicks',
              value: property.performance.callClicks.toLocaleString('en-IN'),
              icon: <PhoneOutlined sx={{ fontSize: 15 }} />,
              iconColor: '#4CAF50',
              bgColor: '#E8F5E9',
              path: '/project-call-clicks',
            },
            {
              label: 'Request Property Clicks',
              value: property.performance.requestClicks.toLocaleString('en-IN'),
              icon: <HomeOutlined sx={{ fontSize: 15 }} />,
              iconColor: '#4A90E2',
              bgColor: '#EAF4FF',
              path: '/project-request-callback',
            },
          ];

          return (
            <Box key={property.id} sx={{ p: 1 }}>

              {/* ====================================================
                  SINGLE MERGED CARD  (click -> property details)
              ===================================================== */}
              <Box
                onClick={() => handlePropertyClick(property.id)}
                sx={{
                  backgroundColor: '#fff',
                  borderRadius: 3,
                  overflow: 'hidden',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                  cursor: 'pointer',
                }}
              >

                {/* ==================================================
                    IMAGES — CAROUSEL
                =================================================== */}
                <Box
                  sx={{
                    display: 'flex',
                    gap: '6px',
                    p: 1.5,
                    height: 240,
                  }}
                >

                  {/* Main Image Carousel (Swipeable) */}
                  <Box
                    onTouchStart={(e) => handleDragStart(property.id, e)}
                    onTouchMove={(e) => handleDragMove(property.id, e)}
                    onTouchEnd={() => handleDragEnd(property.id, totalImages)}
                    onMouseDown={(e) => handleDragStart(property.id, e)}
                    onMouseMove={(e) => handleDragMove(property.id, e)}
                    onMouseUp={() => handleDragEnd(property.id, totalImages)}
                    onMouseLeave={() => {
                      if (
                        isDragging.current &&
                        dragPropertyId.current === property.id
                      ) {
                        handleDragEnd(property.id, totalImages);
                      }
                    }}
                    sx={{
                      flex: 2.4,
                      position: 'relative',
                      borderRadius: '14px',
                      overflow: 'hidden',
                      cursor: isDragging.current ? 'grabbing' : 'grab',
                      userSelect: 'none',
                      touchAction: 'pan-y',
                    }}
                  >

                    {/* Sliding track */}
                    <Box
                      sx={{
                        display: 'flex',
                        width: '100%',
                        height: '100%',
                        transform: `translateX(calc(-${currentIndex * 100}% + ${offset}px))`,
                        transition: isDragging.current
                          ? 'none'
                          : 'transform 0.45s ease-in-out',
                        willChange: 'transform',
                      }}
                    >
                      {property.images.map((img, idx) => (
                        <Box
                          key={idx}
                          component="img"
                          src={img || buildingImage}
                          alt={`${property.title}-${idx}`}
                          draggable={false}
                          onError={(e) => {
                            e.currentTarget.src = buildingImage;
                          }}
                          sx={{
                            minWidth: '100%',
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            flexShrink: 0,
                            display: 'block',
                            pointerEvents: 'none',
                          }}
                        />
                      ))}
                    </Box>


                    {/* APPROVED BADGE */}
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 10,
                        right: 10,
                        backgroundColor: '#A67C52',
                        color: '#fff',
                        px: 1.75,
                        py: 0.4,
                        borderRadius: 10,
                        fontSize: '0.7rem',
                        fontWeight: 600,
                        boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                        pointerEvents: 'none',
                        zIndex: 2,
                      }}
                    >
                      Approved
                    </Box>


                    {/* ══════════════════════════════════════════
                        SHARE + EDIT + MORE ICONS
                    ══════════════════════════════════════════ */}
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 10,
                        left: 10,
                        display: 'flex',
                        gap: 0.5,
                        zIndex: 3,
                      }}
                      // prevent swipe start / card click when pressing these icons
                      onMouseDown={(e) => e.stopPropagation()}
                      onTouchStart={(e) => e.stopPropagation()}
                    >
                      {/* Share */}
                      <IconButton
                        size="small"
                        onClick={(e) => handleShare(e, property)}
                        sx={{
                          bgcolor: 'rgba(255,255,255,0.92)',
                          width: 30,
                          height: 30,
                          boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                          '&:hover': { bgcolor: '#fff' },
                        }}
                      >
                        <ShareIcon sx={{ fontSize: 15, color: '#333' }} />
                      </IconButton>

                      {/* Edit */}
                      <IconButton
                        size="small"
                        onClick={(e) => handleEdit(property.id, e)}
                        sx={{
                          bgcolor: 'rgba(255,255,255,0.92)',
                          width: 30,
                          height: 30,
                          boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                          '&:hover': { bgcolor: '#fff' },
                        }}
                      >
                        <EditOutlined sx={{ fontSize: 15, color: '#333' }} />
                      </IconButton>

                      {/* More (fallback menu) */}
                      <IconButton
                        size="small"
                        onClick={(e) => handleMenuOpen(e, property.id)}
                        sx={{
                          bgcolor: 'rgba(255,255,255,0.92)',
                          width: 30,
                          height: 30,
                          boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                          '&:hover': { bgcolor: '#fff' },
                        }}
                      >
                        <MoreVert sx={{ fontSize: 15, color: '#333' }} />
                      </IconButton>
                    </Box>


                    {/* Dot indicators */}
                    {totalImages > 1 && (
                      <Box
                        sx={{
                          position: 'absolute',
                          bottom: 8,
                          left: '50%',
                          transform: 'translateX(-50%)',
                          display: 'flex',
                          gap: '4px',
                          px: 1,
                          py: 0.4,
                          borderRadius: '10px',
                          bgcolor: 'rgba(0,0,0,0.35)',
                        }}
                      >
                        {property.images.map((_, idx) => (
                          <Box
                            key={idx}
                            sx={{
                              width: 5,
                              height: 5,
                              borderRadius: '50%',
                              bgcolor:
                                currentIndex === idx
                                  ? '#FFFFFF'
                                  : 'rgba(255,255,255,0.5)',
                              transition: 'background 0.2s',
                            }}
                          />
                        ))}
                      </Box>
                    )}
                  </Box>


                  {/* Side Preview Image */}
                  <Box
                    onClick={(e) => {
                      e.stopPropagation();
                      handleNextImage(property.id, totalImages);
                    }}
                    sx={{
                      flex: 1,
                      position: 'relative',
                      borderRadius: '14px',
                      overflow: 'hidden',
                      cursor: 'pointer',
                    }}
                  >
                    <CardMedia
                      component="img"
                      image={
                        property.images[nextIndex] ||
                        property.images[0] ||
                        buildingImage
                      }
                      alt={property.title}
                      sx={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                      }}
                      onError={(e) => {
                        e.currentTarget.src = buildingImage;
                      }}
                    />
                  </Box>
                </Box>


                {/* ==================================================
                    PROPERTY DETAILS
                =================================================== */}
                <Box sx={{ px: 1, pb: 1 }}>

                  {/* Title + Price */}
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="flex-start"
                    mb={1}
                  >
                    <Typography
                      variant="subtitle1"
                      fontWeight={700}
                      sx={{ color: '#222', flex: 1, pr: 1 }}
                    >
                      {property.title}
                    </Typography>

                    <Typography
                      variant="subtitle1"
                      fontWeight={700}
                      sx={{ color: '#A67C52' }}
                    >
                      {property.formattedPrice}
                    </Typography>
                  </Box>


                  {/* Area + Price/Sqft */}
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={1}
                  >
                    <Typography
                      variant="body2"
                      sx={{ color: '#555', fontWeight: 500 }}
                    >
                      {property.area}
                    </Typography>

                    {property.pricePerSqft && (
                      <Typography variant="body2" sx={{ color: '#777' }}>
                        {property.pricePerSqft}
                      </Typography>
                    )}
                  </Box>


                  {/* Location */}
                  <Box display="flex" alignItems="center" mb={2} gap={0.5}>
                    <LocationOn sx={{ fontSize: 16, color: '#777' }} />
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      noWrap
                      sx={{ fontSize: '0.8rem' }}
                    >
                      {property.location}
                    </Typography>
                  </Box>

                  <Divider sx={{ mb: 1.5 }} />

                  {/* BHK + Possession */}
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography
                      variant="body2"
                      fontWeight={600}
                      sx={{ color: '#333' }}
                    >
                      {property.bhk}
                    </Typography>

                    <Typography variant="body2" color="text.secondary">
                      Possession:{' '}
                      <span style={{ color: '#A67C52', fontWeight: 600 }}>
                        {property.possession}
                      </span>
                    </Typography>
                  </Box>
                </Box>


                {/* ==================================================
                    ACTION ROW (Wishlist + Edit + Delete)
                =================================================== */}
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 0.8,
                    px: 1.2,
                    py: 1,
                    borderTop: '1px solid #EAEAEA',
                    backgroundColor: '#FAF8F5',
                  }}
                >
                  {/* Left group: Wishlist */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Box
                      onClick={(e) => handleWishlistClick(property.id, e)}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.4,
                        px: 1,
                        py: 0.5,
                        borderRadius: '7px',
                        border: '1px solid #E8E5E0',
                        backgroundColor: '#fff',
                        cursor: 'pointer',
                        '&:hover': { backgroundColor: '#F5F0E8' },
                      }}
                    >
                      <FavoriteBorder sx={{ fontSize: 14, color: '#5a5a5a' }} />
                      <Typography
                        sx={{
                          fontSize: '0.68rem',
                          fontWeight: 600,
                          color: '#5a5a5a',
                        }}
                      >
                        Wishlist
                      </Typography>
                    </Box>
                  </Box>

                  {/* Right group: Edit + Delete */}
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 0.5,
                      ml: 'auto',
                    }}
                  >
                    {/* Edit */}
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={(e) => handleEdit(property.id, e)}
                      startIcon={<EditOutlined sx={{ fontSize: 14 }} />}
                      sx={{
                        textTransform: 'none',
                        borderRadius: '7px',
                        fontSize: '0.68rem',
                        fontWeight: 600,
                        backgroundColor: '#fff',
                        borderColor: 'rgba(166,124,82,0.5)',
                        color: '#A67C52',
                        px: 1,
                        py: 0.4,
                        whiteSpace: 'nowrap',
                        minWidth: 0,
                        '&:hover': {
                          backgroundColor: 'rgba(166,124,82,0.08)',
                          borderColor: '#A67C52',
                        },
                      }}
                    >
                      Edit
                    </Button>

                    {/* Delete */}
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        setMenuPropertyIdToDelete(property.id);
                        setShowDeleteConfirm(true);
                      }}
                      startIcon={<DeleteOutline sx={{ fontSize: 14 }} />}
                      sx={{
                        textTransform: 'none',
                        borderRadius: '7px',
                        fontSize: '0.68rem',
                        fontWeight: 600,
                        backgroundColor: '#fff',
                        borderColor: 'rgba(231,76,60,0.5)',
                        color: '#E74C3C',
                        px: 1,
                        py: 0.4,
                        whiteSpace: 'nowrap',
                        minWidth: 0,
                        '&:hover': {
                          backgroundColor: 'rgba(231,76,60,0.08)',
                          borderColor: '#E74C3C',
                        },
                      }}
                    >
                      Delete
                    </Button>
                  </Box>
                </Box>


                {/* ==================================================
                    PROPERTY PERFORMANCE (inside same card)
                =================================================== */}
                <Box
                  sx={{
                    px: 1,
                    pb: 1,
                    pt: 2,
                    borderTop: '1px solid #EAEAEA',
                  }}
                >
                  {/* Performance header */}
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                  >
                    <Typography
                      variant="subtitle1"
                      fontWeight={700}
                      sx={{ color: '#333' }}
                    >
                      Property Performance
                    </Typography>

                    <Box
                      onClick={(e) => e.stopPropagation()}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5,
                        border: '1px solid #EAEAEA',
                        borderRadius: 1.5,
                        px: 1.5,
                        py: 0.5,
                        backgroundColor: '#fff',
                        cursor: 'pointer',
                        flexShrink: 0,
                      }}
                    >
                      <CalendarTodayOutlined sx={{ fontSize: 14, color: '#555' }} />
                      <Typography
                        variant="caption"
                        sx={{ color: '#555', fontWeight: 500 }}
                      >
                        Last 31 days
                      </Typography>
                      <KeyboardArrowDownOutlined sx={{ fontSize: 16, color: '#555' }} />
                    </Box>
                  </Box>

                  {/* Metrics grid (each box is clickable) */}
                  <Box
                    sx={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                      gap: 0.75,
                    }}
                  >
                    {performanceMetrics.map((metric, index) => (
                      <Box
                        key={index}
                        onClick={(e) =>
                          handleMetricClick(e, metric.path, property.id)
                        }
                        sx={{
                          border: '1px solid #F0F0F0',
                          borderRadius: 2,
                          p: 0.75,
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 0.5,
                          minWidth: 0,
                          height: '100%',
                          backgroundColor: '#fff',
                          boxShadow: '0 1px 4px rgba(0,0,0,0.02)',
                          cursor: 'pointer',
                          '&:hover': { backgroundColor: '#FAFAFA' },
                        }}
                      >
                        <Box
                          display="flex"
                          alignItems="flex-start"
                          gap={0.5}
                          sx={{ minWidth: 0 }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              width: 24,
                              height: 24,
                              borderRadius: '50%',
                              backgroundColor: metric.bgColor,
                              color: metric.iconColor,
                              flexShrink: 0,
                            }}
                          >
                            {metric.icon}
                          </Box>

                          <Typography
                            sx={{
                              color: '#666',
                              fontSize: '0.6rem',
                              lineHeight: 1.15,
                              minWidth: 0,
                              overflowWrap: 'anywhere',
                            }}
                          >
                            {metric.label}
                          </Typography>
                        </Box>

                        <Typography
                          fontWeight={700}
                          sx={{
                            color: '#222',
                            fontSize: '0.9rem',
                            lineHeight: 1.2,
                            mt: 'auto',
                            overflowWrap: 'anywhere',
                          }}
                        >
                          {metric.value}
                        </Typography>

                        <Typography
                          sx={{
                            color: '#999',
                            fontSize: '0.55rem',
                            lineHeight: 1.2,
                            overflowWrap: 'anywhere',
                          }}
                        >
                          Current total
                        </Typography>
                      </Box>
                    ))}
                  </Box>

                  {/* Detailed performance */}
                  <Box
                    onClick={(e) => e.stopPropagation()}
                    sx={{
                      mt: 2,
                      pt: 2,
                      borderTop: '1px solid #EAEAEA',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      cursor: 'pointer',
                      color: '#1976D2',
                      '&:hover': { textDecoration: 'underline' },
                    }}
                  >
                    <BarChartOutlined sx={{ fontSize: 18, mr: 0.5 }} />
                    <Typography variant="body2" fontWeight={600}>
                      View Detailed Performance
                    </Typography>
                    <ChevronRight sx={{ fontSize: 18, ml: 0.5 }} />
                  </Box>
                </Box>

              </Box>
            </Box>
          );
        })}

      </Box>


      {/* ================================================================
          MENU (fallback for MoreVert)
      ================================================================= */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClick={(e) => e.stopPropagation()}
      >
        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            handleEdit(menuPropertyId, e);
            handleMenuClose();
          }}
        >
          Edit
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            setMenuPropertyIdToDelete(menuPropertyId);
            setShowDeleteConfirm(true);
            handleMenuClose();
          }}
        >
          Delete
        </MenuItem>
      </Menu>


      {/* ================================================================
          ALERTS
      ================================================================= */}
      {showShareSuccess && (
        <ShareCopySuccessAlert
          message={alertMessage}
          onClose={() => {
            setShowShareSuccess(false);
            setAlertMessage('');
          }}
        />
      )}
      {showShareFailure && (
        <ShareCopyFailureAlert
          message={alertMessage}
          onClose={() => {
            setShowShareFailure(false);
            setAlertMessage('');
          }}
        />
      )}
      {showDeleteSuccess && (
        <DeleteSuccessAlert
          message={alertMessage}
          onClose={() => {
            setShowDeleteSuccess(false);
            setAlertMessage('');
          }}
        />
      )}
      {showDeleteFailure && (
        <DeleteFailureAlert
          message={alertMessage}
          onClose={() => {
            setShowDeleteFailure(false);
            setAlertMessage('');
          }}
        />
      )}
      {showDeleteConfirm && (
        <DeleteConfirmAlert
          message={`Are you sure you want to delete property ID ${menuPropertyIdToDelete}?`}
          onOk={() => {
            setShowDeleteConfirm(false);
            handleDelete();
          }}
          onCancel={() => setShowDeleteConfirm(false)}
        />
      )}


      {/* BOTTOM NAVIGATION */}
      <BottomNavbar />

    </Box>
  );
};


export default NewLaunchingProfile;